import React from 'react'
import { useStateMachine } from 'little-state-machine'
import axios, { AxiosInstance } from 'axios'
import { Rxios } from 'rxios'
import { CrmAccessTokenPayloadDto } from '@sparling/financial-common'
import { ApplicationStore } from '../../states'

import {
  removeAuthToken,
  removeIsRefresh,
  removeLastLocation,
  removeUserId,
  removeUserName,
  removeUserRole,
  updateAuthToken,
  updateIsRefresh,
  updateLastLocation,
  updateUserId,
  updateUserName,
  updateUserRole,
  updateAccessTokenData,
  removeAccessTokenData,
} from '../../actions'
import { restCommon, rxios } from '../../utils/NetUtils'

const errorInitFunction = () => {
  throw new Error(`AppStateContext not initialized`)
}

export const AppStateContext = React.createContext<{
  getAuthToken: () => string | undefined
  getUserName: () => string | undefined
  getUserId: () => number | undefined
  getUserRole: () => string | undefined
  getIsRefresh: () => boolean | undefined
  getLastLocation: () => string | undefined
  restClient: AxiosInstance
  setAuthTokenInStore: (token: string | undefined) => void
  removeAuthTokenFromStore: () => void
  setUserNameInStore: (userName: string | undefined) => void
  removeUserNameFromStore: () => void
  setUserIdInStore: (userId: number | undefined) => void
  removeUserIdFromStore: () => void
  setUserRoleInStore: (userRole: string | undefined) => void
  removeUserRoleFromStore: () => void
  setIsRefreshInStore: (isRefresh: boolean | undefined) => void
  removeIsRefreshFromStore: () => void
  setLastLocationInStore: (lastLocation: string | undefined) => void
  removeLastLocationFromStore: () => void
  setAuthAccessTokenPayloadInStore: (value: CrmAccessTokenPayloadDto | undefined) => void
  getAuthAccessTokenPayloadInStore: () => CrmAccessTokenPayloadDto
  removeAuthAccessTokenPayloadFromStore: () => void
  rxiosClient: Rxios
  rxiosUploadFile: Rxios
  rxiosGeneralClient: Rxios
  isLoggedIn: boolean
}>({
  getAuthToken: errorInitFunction,
  getUserName: errorInitFunction,
  getUserId: errorInitFunction,
  getUserRole: errorInitFunction,
  getIsRefresh: errorInitFunction,
  getLastLocation: errorInitFunction,
  restClient: restCommon,
  setAuthTokenInStore: errorInitFunction,
  removeAuthTokenFromStore: errorInitFunction,
  setUserNameInStore: errorInitFunction,
  removeUserNameFromStore: errorInitFunction,
  setUserIdInStore: errorInitFunction,
  removeUserIdFromStore: errorInitFunction,
  setUserRoleInStore: errorInitFunction,
  removeUserRoleFromStore: errorInitFunction,
  setIsRefreshInStore: errorInitFunction,
  removeIsRefreshFromStore: errorInitFunction,
  setLastLocationInStore: errorInitFunction,
  removeLastLocationFromStore: errorInitFunction,
  setAuthAccessTokenPayloadInStore: errorInitFunction,
  getAuthAccessTokenPayloadInStore: errorInitFunction,
  removeAuthAccessTokenPayloadFromStore: errorInitFunction,
  rxiosClient: rxios,
  rxiosUploadFile: rxios,
  rxiosGeneralClient: rxios,
  isLoggedIn: false,
})

export const AppStateProvider: React.FC = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { state } = useStateMachine<ApplicationStore>()

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setAuthTokenInStore = useStateMachine<ApplicationStore>({ updateAuthToken }).actions.updateAuthToken as (
    token: string | undefined,
  ) => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeAuthTokenFromStore = useStateMachine<ApplicationStore>({ removeAuthToken }).actions
    .removeAuthToken as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setUserNameInStore = useStateMachine<ApplicationStore>({ updateUserName }).actions.updateUserName as (
    userName: string | undefined,
  ) => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeUserNameFromStore = useStateMachine<ApplicationStore>({ removeUserName }).actions
    .removeUserName as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setUserIdInStore = useStateMachine<ApplicationStore>({ updateUserId }).actions.updateUserId as (
    userId: number | undefined,
  ) => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeUserIdFromStore = useStateMachine<ApplicationStore>({ removeUserId }).actions.removeUserId as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setUserRoleInStore = useStateMachine<ApplicationStore>({ updateUserRole }).actions.updateUserRole as (
    userRole: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeUserRoleFromStore = useStateMachine<ApplicationStore>({ removeUserRole }).actions
    .removeUserRole as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setIsRefreshInStore = useStateMachine<ApplicationStore>({ updateIsRefresh }).actions.updateIsRefresh as (
    isRefresh: boolean | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeIsRefreshFromStore = useStateMachine<ApplicationStore>({ removeIsRefresh }).actions
    .removeIsRefresh as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setLastLocationInStore = useStateMachine<ApplicationStore>({ updateLastLocation }).actions
    .updateLastLocation as (lastLocation: string | undefined) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeLastLocationFromStore = useStateMachine<ApplicationStore>({ removeLastLocation }).actions
    .removeLastLocation as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setAuthAccessTokenPayloadInStore = useStateMachine<ApplicationStore>({ updateAccessTokenData }).actions
    .updateAccessTokenData as (value: CrmAccessTokenPayloadDto | undefined) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeAuthAccessTokenPayloadFromStore = useStateMachine<ApplicationStore>({ removeAccessTokenData }).actions
    .removeAccessTokenData as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getAuthToken = () => state.authToken as string

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getUserName = () => state.userName as string

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getUserId = () => state.userId as number

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getUserRole = () => state.userRole as string

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getIsRefresh = () => state.isRefresh as boolean

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getLastLocation = () => state.lastLocation as string

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getAuthAccessTokenPayloadInStore = () => state.accessTokenData as CrmAccessTokenPayloadDto

  const restClient = axios.create({
    baseURL: `${process.env.REACT_APP_SERVER_URL}/crm`,
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  })

  const rxiosClient = new Rxios({
    baseURL: `${process.env.REACT_APP_SERVER_URL}/crm`,
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  })

  const rxiosUploadFile = new Rxios({
    baseURL: `${process.env.REACT_APP_SERVER_URL}/crm`,
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
      'Content-Type': 'multipart/form-data',
    },
  })

  const rxiosGeneralClient = new Rxios({
    baseURL: `${process.env.REACT_APP_SERVER_URL}`,
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  })

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const isLoggedIn = (!!state.authToken && state.authToken.length >= 40) as boolean

  return (
    <AppStateContext.Provider
      value={{
        getAuthToken,
        getUserName,
        getUserId,
        getUserRole,
        getIsRefresh,
        getLastLocation,
        restClient,
        setAuthTokenInStore,
        removeAuthTokenFromStore,
        setUserNameInStore,
        removeUserNameFromStore,
        setUserIdInStore,
        removeUserIdFromStore,
        setUserRoleInStore,
        removeUserRoleFromStore,
        setIsRefreshInStore,
        removeIsRefreshFromStore,
        setLastLocationInStore,
        removeLastLocationFromStore,
        setAuthAccessTokenPayloadInStore,
        getAuthAccessTokenPayloadInStore,
        removeAuthAccessTokenPayloadFromStore,
        rxiosClient,
        rxiosUploadFile,
        rxiosGeneralClient,
        isLoggedIn,
      }}
    >
      {children}
    </AppStateContext.Provider>
  )
}
